import { render, staticRenderFns } from "./Doorphone.vue?vue&type=template&id=707225c8&scoped=true"
import script from "./Doorphone.vue?vue&type=script&lang=js"
export * from "./Doorphone.vue?vue&type=script&lang=js"
import style0 from "./Doorphone.vue?vue&type=style&index=0&id=707225c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707225c8",
  null
  
)

export default component.exports